export default __webpack_public_path__ + "static/media/premier.55a90673.svg";